"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _handleCkeditorEvents = require("./utils/handleCkeditorEvents");

require("../assets/index.less");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PanoRichText = /*#__PURE__*/function (_PureComponent) {
  _inherits(PanoRichText, _PureComponent);

  var _super = _createSuper(PanoRichText);

  function PanoRichText() {
    _classCallCheck(this, PanoRichText);

    return _super.apply(this, arguments);
  }

  _createClass(PanoRichText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          _this$props$extraCked = _this$props.extraCkeditorCssUrl,
          extraCkeditorCssUrl = _this$props$extraCked === void 0 ? "" : _this$props$extraCked,
          _this$props$bodyClass = _this$props.bodyClassName,
          bodyClassName = _this$props$bodyClass === void 0 ? "" : _this$props$bodyClass,
          initValue = _this$props.initValue,
          handleNotification = _this$props.handleNotification,
          noFile = _this$props.noFile,
          className = _this$props.className,
          editorRef = _this$props.editorRef,
          handleUpload = _this$props.handleUpload,
          toolbarGroup = _this$props.toolbarGroup,
          removeItem = _this$props.removeItem,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$ckeditorJ = _this$props.ckeditorJsUrl,
          ckeditorJsUrl = _this$props$ckeditorJ === void 0 ? "https://ssl-static2.720static.com/oms/static/js/ckeditor_4.11.4_full_html5video_v5/ckeditor.js" : _this$props$ckeditorJ,
          _this$props$ckeditorC = _this$props.ckeditorCssUrl,
          ckeditorCssUrl = _this$props$ckeditorC === void 0 ? "https://ssl-static2.720static.com/oms/static/js/ckeditor_4.11.4_full_html5video_v5/contents.css?t=5" : _this$props$ckeditorC;
      var script = document.createElement("script");
      var body = document.getElementsByTagName("body")[0];
      var hideVideoTagFullScreenBtnCssUrl = "https://ssl-static2.720static.com/oms/static/css/rich-text-editor.css";
      script.setAttribute("src", ckeditorJsUrl);
      body.insertBefore(script, body.firstChild);

      script.onload = function () {
        //必传属性校验
        if (!editorRef) {
          throw new Error("请传入editorRef属性");
        }

        if (!handleNotification) {
          throw new Error("请传入handleNotification属性");
        } //处理extraCkeditorCssUrl


        var contentsCss;

        if (Array.isArray(extraCkeditorCssUrl)) {
          contentsCss = [hideVideoTagFullScreenBtnCssUrl, ckeditorCssUrl].concat(_toConsumableArray(extraCkeditorCssUrl));
        } else {
          contentsCss = [hideVideoTagFullScreenBtnCssUrl, ckeditorCssUrl, extraCkeditorCssUrl];
        } //初始化富文本编辑器


        var editor = CKEDITOR.replace("editor", {
          //强制使用简体中文, 不然如果浏览器设置了其他语言, 语言包缺失就会导致报错无法使用
          //而且有的地方手动翻译成了中文, 如果使用其他语言, 就算不报错也会出现中文/其他语言夹杂的情况
          //从而影响用户体验
          language: "zh-cn",
          width: style.width || "100%",
          //设置到整个编辑器: div#cke_editor上
          height: style.height || "200px",
          //设置到编辑区域: div.cke_contents上(默认值就是200所以这里设置200)
          image_previewText: " ",
          filebrowserUploadUrl: "占位非空字符串",
          //保留以正常显示上传对话框中的上传按钮
          //toolbarGroup
          toolbarGroups: toolbarGroup ? toolbarGroup : [{
            name: "document",
            groups: ["mode", "document", "doctools"]
          }, {
            name: "clipboard",
            groups: ["clipboard", "undo"]
          }, {
            name: "editing",
            groups: ["find", "selection", "spellchecker"]
          }, {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"]
          }, {
            name: "insert",
            groups: ["insert"]
          }, {
            name: "styles"
          }, {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"]
          }, {
            name: "links"
          }, {
            name: "colors"
          }],
          //需要从toolbarGroup中移除的按钮
          removeButtons: removeItem ? removeItem : "Flash",
          //禁用缩放按钮
          resize_enabled: false,
          //移除对话框的tab按钮
          removeDialogTabs: ["image:Link", "image:advanced", "html5video:advanced", "link:upload", "link:advanced", "iframe:advanced"].join(";"),
          //移除拖拽上传功能, 在插件目录中自己写一个dropoff插件, 用这个插件来移除拖拽上传功能
          //方案来自: https://stackoverflow.com/questions/35650448/in-ckeditor-inline-instances-how-does-one-disable-drag-and-dropping
          //暂不使用该插件, 因为可能导致图片dnd时图片消失的bug
          // extraPlugins:'dropoff',
          //自定义移除格式当中的内容(目前已没有格式按钮,故暂时注释)
          // format_tags:"p;h1;h2;h3;h4;h5;h6;div",
          //强制去除粘贴内容中的样式, 只留下纯文本内容, 复制word内容过来也适用
          //由true改为CKEDITOR.DATA_TRANSFER_EXTERNAL, 方案来自:
          //https://github.com/ckeditor/ckeditor-dev/issues/3215
          forcePasteAsPlainText: CKEDITOR.DATA_TRANSFER_EXTERNAL,
          //为富文本编辑区域iframe>body添加类名
          bodyClass: bodyClassName,
          //这句是用来解决点击源码按钮界面切换导致video标签内容被重置的问题(目前已没有源码按钮,先注释)
          // allowedContent:true,
          //编辑器内容区域额外样式设置
          contentsCss: contentsCss,
          //关闭对话框无确认弹窗
          dialog_noConfirmCancel: true
        }); //ckeditor事件处理

        (0, _handleCkeditorEvents.handleCkeditorEvents)({
          handleNotification: handleNotification,
          initValue: initValue,
          noFile: noFile,
          className: className,
          editor: editor,
          handleUpload: handleUpload
        }); //将editor传递出去

        editorRef(editor);
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "editor"
      });
    }
  }]);

  return PanoRichText;
}(_react.PureComponent);

var _default = PanoRichText;
exports["default"] = _default;